const isImageByFileName = (text: string) => {
  return (
    text.includes('.jpg') || text.includes('.jpeg') || text.includes('.png')
  )
}

export default isImageByFileName
